<template>
  <b-container class="mt-5" ref="dashboard" :class="dashboardHeight">
    <h1 class="text-center">{{ $t('dashboardTitleCharts') }}</h1>
    <div :class="cromaClass" class="mb-5" v-if="$i18n.locale === 'en'">
      <div v-for="(item, index) of questionsEn" v-bind:key="index">
        <div v-if="graphSelected === null" style="height: 100px">

        </div>
        <div v-if="index+1 === graphSelected">
          <b-row>
            <b-col :cols="item.question.includes('3') ? 8 : 10">
              <h3 class=" mt-5 text-center">{{ item.question }}</h3>
            </b-col>
            <b-col cols="12" align-self="start">
              <DoughnutChart v-if="selected[0] === 'donut'" class="mt-3 mx-auto" :options="chartOptions"
                             :label="item.question" :chart-data="item.total"></DoughnutChart>
              <PieChart v-else-if="selected[0] === 'quesito'" class="mt-3 mx-auto" :options="chartOptions"
                        :label="item.question" :chart-data="item.total"></PieChart>
              <BarChart v-else-if="selected[0] === 'barras'" class="mt-3 mx-auto"
                        :label="item.question" :chart-data="item.total"></BarChart>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div :class="cromaClass" class="mb-5" v-if="$i18n.locale === 'es'">
      <div v-for="(item, index) of questionsEs" v-bind:key="index">
        <div v-if="graphSelected === null" style="height: 100px">

        </div>
        <div v-if="index+1 === graphSelected">
          <b-row>
            <b-col :cols="item.question.includes('3') ? 8 : 10">
              <h3 class=" mt-5 text-center">{{ item.question }}</h3>
            </b-col>
            <b-col cols="12" align-self="start">
              <DoughnutChart v-if="selected[0] === 'donut'" class="mt-3 mx-auto" :options="chartOptions"
                             :label="item.question" :chart-data="item.total"></DoughnutChart>
              <PieChart v-else-if="selected[0] === 'quesito'" class="mt-3 mx-auto" :options="chartOptions"
                        :label="item.question" :chart-data="item.total"></PieChart>
              <BarChart v-else-if="selected[0] === 'barras'" class="mt-3 mx-auto"
                        :label="item.question" :chart-data="item.total"></BarChart>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div :class="cromaClass" class="mb-5" v-if="$i18n.locale === 'cat'">
      <div v-for="(item, index) of questionsCat" v-bind:key="index">
        <div v-if="graphSelected === null" style="height: 100px">

        </div>
        <div v-if="index+1 === graphSelected">
          <b-row>
            <b-col :cols="item.question.includes('3') ? 8 : 10">
              <h3 class=" mt-5 text-center">{{ item.question }}</h3>
            </b-col>
            <b-col cols="12" align-self="start">
              <DoughnutChart v-if="selected[0] === 'donut'" class="mt-3 mx-auto" :options="chartOptions"
                             :label="item.question" :chart-data="item.total"></DoughnutChart>
              <PieChart v-else-if="selected[0] === 'quesito'" class="mt-3 mx-auto" :options="chartOptions"
                        :label="item.question" :chart-data="item.total"></PieChart>
              <BarChart v-else-if="selected[0] === 'barras'" class="mt-3 mx-auto"
                        :label="item.question" :chart-data="item.total"></BarChart>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>


    <b-row class="mt-5 ">
      <b-col cols="12">

        <b-form-select class="mb-5 mx-auto " v-model="graphSelected"
                       :options="$i18n.locale === 'es' ? graphPageEs : $i18n.locale === 'en' ? graphPageEn : graphPageCat">

        </b-form-select>
      </b-col>
      <b-col>
        <b-form-group label="Select Chart Type:">
          <b-form-checkbox-group
              id="checkbox-group-1"
              v-model="selected"
              :options="chartTypes"
              name="flavour-1"
          ></b-form-checkbox-group>
        </b-form-group>
      </b-col>
      <b-col v-if="isChromaActive" align-self="center">
        <b-form-checkbox v-model="checked" name="check-button" switch v-on:change="changeCroma()">
          Chroma
        </b-form-checkbox>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import app from "../firebaseConfig/config";
import DoughnutChart from "../components/DoughnutChart";
import apiService from "../service/service";
import PieChart from "../components/PieChart";
import BarChart from "../components/BarChart";
/*
import Cryptr from "crypto-js";
*/

export default {
  name: "Dashboard",
  components: {
    BarChart,
    PieChart,
    DoughnutChart,
  },
  data() {
    return {
      selected: [],
      chartTypes: [
        {text: 'Donut', value: 'donut'},
        {text: 'Quesito', value: 'quesito'},
        {text: 'Barras', value: 'barras'}
      ],
      cromaClass: '',
      checked: false,
      questionsEs: [],
      questionsEn: [],
      questionsCat: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'right',
          align: 'center',
        },
        /*tooltips: {enabled: false},
        hover: {mode: null},*/
        plugins: {
          labels: [
            {
              render: 'percentage',
              precision: 0,
              fontColor: '#fff',
              fontSize: 18,
              fontStyle: 'bold',
              shadowColor: 'black',
              showZero: true,
              textShadow: true,
            },
            /*   {
                   render: 'label',
                   position: 'outside',
                   fontSize: 20,
                   fontStyle: 'bold',
                   //arc: true,
               },*/
          ]
        },
      },
      eventQuestions: [],
      graphSelected: null,
      graphPageEs: [],
      graphPageEn: [],
      graphPageCat: [],
      dashboardHeight: 'dashboardHeight',
      isChromaActive: false
    };
  },
  methods: {
    /**
     * Get value of cookie passed by param
     * @param cname
     * @returns {string}
     */
    getCookie(cname) {
      const name = cname + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    /**
     * Get questions answers for realTime Database
     * @param snapshot
     */
    async getAnswers(snapshot) {
      try {
        await this.getQuestions()
        let index = 0;
        this.questionsEn.length = 0;
        this.questionsEs.length = 0;
        this.questionsCat.length = 0;
        this.graphPageEs.length = 0;
        this.graphPageEs.push({
          value: null, text: 'Selecciona una opción'
        })
        this.graphPageEn.length = 0;
        this.graphPageEn.push({
          value: null, text: 'Select an option'
        })
        this.graphPageCat.length = 0;
        this.graphPageCat.push({
          value: null, text: 'Selecciona una opció'
        })
        snapshot.forEach(res => {
          const answers = []
          res.forEach(answ => {
            answers.push(answ.val().option)
          })
          const counts = {};
          const totalByLetterEn = [];
          const totalByLetterEs = [];
          const totalByLetterCat = [];
          const letters = [...new Set(answers)]
          //Counts n of times appears count variable in specific array
          for (let i = 0; i < answers.length; i++) {
            const num = answers[i];
            counts[num] = counts[num] ? counts[num] + 1 : 1;
          }
          /*//push letter and counts times appears
          for (let x = 0; x < letters.length; x++) {
            totalByLetterEn.push({letter: letters[x], total: counts[letters[x]]})
            totalByLetterEs.push({letter: letters[x], total: counts[letters[x]]})
            totalByLetterCat.push({letter: letters[x], total: counts[letters[x]]})
          }*/

          for (const aws of this.eventQuestions[0].events[0].questionsEs[index].answers) {
            const isAnswered = letters.includes(`${aws.answerLetter.toString()}: ${aws.answer}`)
            isAnswered ? null : totalByLetterEs.push({
              letter: `${aws.answerLetter.toString()}: ${aws.answer}`,
              total: counts[aws.answerLetter]
            })
          }
          for (const aws of this.eventQuestions[0].events[0].questionsEn[index].answers) {
            const isAnswered = letters.includes(`${aws.answerLetter.toString()}: ${aws.answer}`)
            isAnswered ? null : totalByLetterEn.push({
              letter: `${aws.answerLetter.toString()}: ${aws.answer}`,
              total: counts[aws.answerLetter]
            })
          }
          for (const aws of this.eventQuestions[0].events[0].questionsCat[index].answers) {
            const isAnswered = letters.includes(`${aws.answerLetter.toString()}: ${aws.answer}`)
            isAnswered ? null : totalByLetterCat.push({
              letter: `${aws.answerLetter.toString()}: ${aws.answer}`,
              total: counts[aws.answerLetter]
            })
          }

          this.graphPageEs.push(
              {value: index + 1, text: `${this.eventQuestions[0].events[0].questionsEs[index].question.toUpperCase()}`},
          )
          this.graphPageEn.push(
              {value: index + 1, text: `${this.eventQuestions[0].events[0].questionsEn[index].question.toUpperCase()}`},
          )
          this.graphPageCat.push(
              {
                value: index + 1,
                text: `${this.eventQuestions[0].events[0].questionsCat[index].question.toUpperCase()}`
              },
          )
          /*this.questions.push({
            question: `${this.$i18n.t('dashboardTitleGraph')} ${index + 1}`,
            total: totalByLetter
          })*/

          this.questionsEs.push({
            question: `${this.eventQuestions[0].events[0].questionsEs[index].question.toUpperCase()}`,
            total: totalByLetterEs.sort((a, b) => a.letter.localeCompare(b.letter))
          })
          this.questionsEn.push({
            question: `${this.eventQuestions[0].events[0].questionsEn[index].question.toUpperCase()}`,
            total: totalByLetterEn.sort((a, b) => a.letter.localeCompare(b.letter))
          })
          this.questionsCat.push({
            question: `${this.eventQuestions[0].events[0].questionsCat[index].question.toUpperCase()}`,
            total: totalByLetterCat.sort((a, b) => a.letter.localeCompare(b.letter))
          })

          console.log(this.questionsCat)

          index++
        })
      } catch (e) {
        console.log(e.message)
      }
    },
    /**
     * Change graph to chroma for Vmix
     */
    changeCroma() {
      if (!this.checked) {
        this.cromaClass = 'croma'
        this.$store.commit('updateFooterClass', 'footerDisplayNone')
        this.$store.commit('updateNavBarClass', 'navDisplayNone')
      } else {
        this.cromaClass = ''
        this.$store.commit('updateFooterClass', 'footerRelative')
        this.$store.commit('updateNavBarClass', '')
      }
    },
    /**
     * Verify if user have role graph or secretary
     * @returns {Promise<void>}
     */
    async verifyUser() {
      const email = this.getCookie('email')
      try {
        const verifyUser = {email: email}
        const accessToken = await app.auth().currentUser.getIdToken(true)

        const response = await apiService.verifyCredentials(verifyUser, accessToken)
        if (response.data.user.role !== 'graph' && response.data.user.role !== 'secretary' && response.data.user.role !== 'admin') await this.$router.push({path: '/login'})
      } catch (e) {
        console.log(e.message)
        await this.$router.push({path: '/login'})
      }
    },
    /**
     * Verify Height of user widow for make Admin more responsive
     */
    matchHeight() {
      const totalComponentsHeight = this.$refs.dashboard.clientHeight + 87 + 100
      document.documentElement.clientHeight <= 819 ? this.dashboardHeight = 'min-vh-100' : this.dashboardHeight = 'dashboardHeight'
      if (totalComponentsHeight < document.documentElement.clientHeight) {
        if (this.footerClass !== 'footer') this.$store.commit('updateFooterClass', 'footer')
      } else {
        if (this.footerClass !== 'footerRelative') this.$store.commit('updateFooterClass', 'footerRelative')
      }
    },
    async getQuestions() {
      try {
        const accessToken = await app.auth().currentUser.getIdToken(true)
        const response = await apiService.getQuestions(accessToken, localStorage.getItem('eventCode'))
        this.eventQuestions.push(response.data)
        this.isChromaActive = response.data.isChromaActive
        console.log(response.data)
        console.log(localStorage.getItem('eventCode'))
      } catch (e) {
        console.log(e.message)
      }
    }
  },
  mounted() {
    this.matchHeight()
    /**
     * Add Listener when user resize window and check Height
     */
    window.addEventListener("resize", this.matchHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.matchHeight);
  },
  created() {
    this.verifyUser()
    const code = this.getCookie('code').toLowerCase().replace(/\s/g, "")
    if (!code) localStorage.getItem('code')
    const answersRef = app.database().ref(`/lallucana/${code}/answers`)
    answersRef.on('value', this.getAnswers)
  }
}
</script>

<style scoped>
.croma {
  background-color: rgb(0, 255, 0);
  height: 60vh;
}

.dashboardHeight {
  height: 83vh;
}
</style>
